<template>
  <div class='my-order-admin'>
    <sub-nav :navs='navs' />
    <h2>订单操作</h2>
    <div class='order-type-wrapper'>
      <a :class='{"active": orderType === "NOT_CONFIRM"}' href='javascript:;' class='btn-order-type' @click='toggleOrderType("NOT_CONFIRM")'>待确认</a>
      <a :class='{"active": orderType === "IS_CONFIRM"}' href='javascript:;' class='btn-order-type' @click='toggleOrderType("IS_CONFIRM")'>已确认</a>
    </div>
    <div class='content'>
      <!-- 列表 -->
      <div class='table-wrapper' >
        <table v-loading='loading' class='table'>
          <thead>
            <tr>
              <td v-for='item in tables' :key='item.idx' :style='{width:item.width}'>{{ item.label }}</td>
            </tr>
          </thead>
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              <td v-for='t in tables' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "check"' class='cell'>
                  <a v-if='item.status === 0' href='javascript:;' class='btn-approve' @click='check("CONFIRM",item)'>确认</a>
                  <a v-else href='javascript:;' class='btn-reject' @click='check("CANCEL",item)'>取消</a>
                </div>
                <div v-else-if='t.props === "receive_num"' class='cell'>
                  <!-- 待确认可编辑实领数量 -->
                  <div v-if='orderType==="NOT_CONFIRM"' class='cell-nums'>
                    <i class='iconfont icon-minus' @click='editReceiveNum("MINUS",item)'/>
                    <input v-model='item.receive_num' type='tel' @change='changeReceiveNum(item)'>
                    <i class='iconfont icon-add' @click='editReceiveNum("ADD",item)'/>
                  </div>
                  <!-- 取消确认 不可编辑实领数量 -->
                  <span v-else>{{ item.receive_num }}</span>
                </div>

                <div v-else-if='t.props === "remark"' class='cell'>
                  <input v-if='orderType==="NOT_CONFIRM"' v-model='item.remark' type='text' class='remark'>
                  <span v-else>{{ item.remark }}</span>
                </div>
                <div v-else class='cell'>{{ item[t.props] | propsFilter(t.props) }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>
      </div>
      <page :total='total' @change='changePage'/>
      <a href='javascript:;' class='btn-back' @click='goBack'>返回</a>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page'
import SubNav from '@/components/SubNav'

import { ADMIN_ORDER_LIST, CANCEL_ORDER_CONFIRM, CONFIRM_ORDER } from '@/api'

export default {
  components: {
    Page,
    SubNav
  },
    
  filters: {
    propsFilter(val,props) {
      let result
      switch (props) {
        case 'price':
          result = '￥' + val
          break
        case 'discount':
          result = val + '%'
          break
        case 'total_price':
          result = '￥' + val 
          break
        case 'total_discount':
          result = '￥' + val
          break
        default:
          result = val
          break    
      }
      return result
    }
  },
  data() {
    return {
      loading: false,
      page: 1,
      total: 0,
      navs: [{label: '个人中心', path: '/my'}],
      tableItems: [
        { idx: 1, label: '序号', props: 'idx', width: '50px'},
        { idx: 2, label: '学校', props: 'school', width: '100px'},
        { idx: 3, label: '院系', props: 'department', width: '120px'},
        { idx: 4, label: '年级专业班级', props: 'profession_class',width: '120px'},
        { idx: 5, label: '批发单号', props: 'wholesale_no', width: '120px'},
        { idx: 6, label: '书号', props: 'book_no', width: '150px'},
        { idx: 7, label: '书名', props: 'book_name',width: '200px'},
        { idx: 8, label: '单价', props: 'price',width: '80px'},
        { idx: 9, label: '折扣', props: 'discount',width: '60px'},
        { idx: 10, label: '码洋', props: 'total_price',width: '120px'},
        { idx: 11, label: '实洋', props: 'total_discount',width: '120px'},
        { idx: 12, label: '发货（套）', props: 'deliver_num',width: '100px'},
        { idx: 13, label: '退货（套）', props: 'return_num',width: '100px'},
        { idx: 14, label: '实领(套)', props: 'receive_num',width: '150px'},
        { idx: 16, label: '备注', props: 'remark',width: '150px'},
        { idx: 15, label: '操作', props: 'check',width: '150px'},
      ],
      orderType: 'NOT_CONFIRM',
      list: []
    }
  },

  computed: {
    tables() {
      return this.tableItems
    },
        
    // 查询参数
    params() {
      let para = {
        page: this.page,
        status: this.orderType === 'NOT_CONFIRM' ? 0 : 1,  // 0：待确认， 1： 待付款
      }
      return Object.assign(para,this.$store.state.adminOrderParams)
    }
  },

  created() {
    this._initOrderType()
    this.getList()
    this.setActiveBar('MY')
  },
  methods: {
    // 编辑实领数量- 修改数量
    changeReceiveNum(item) {
      if (isNaN(item.receive_num - 0)) {
        item.receive_num = item.deliver_num - item.return_num
      } else if (item.receive_num - 0 < 0) {
        item.receive_num = 0
      } else if (item.receive_num - 0 > item.deliver_num) {
        item.receive_num = item.deliver_num
      } else {
        item.receive_num = Math.floor(item.receive_num)
      }
      item.return_num = item.deliver_num - Math.floor(item.receive_num)
    },

    // 编辑实领数量- +-按钮
    editReceiveNum(type,item) {
      if (type === 'ADD') {
        item.receive_num < item.deliver_num ? item.receive_num ++ : item.receive_num
                
      } else {
        item.receive_num > 0 ? item.receive_num -- : item.receive_num
      }    
      item.return_num = item.deliver_num - item.receive_num
    },

    // 切换订单类型
    toggleOrderType(type) {
      this.orderType = type
      this.page = 1
      this.list = []
      this.getList()
    },

    // 操作
    check(type,item) {
      if (type === 'CANCEL') this.cancelConfirm(item)   // 取消确认
      else this.confirmOrder(item)
    },

    // 确认订单
    confirmOrder(item) {
      let para = {
        order_no: item.order_no,
        receive_num: item.receive_num,
        remark: item.remark
      }
      this.loading = true
      CONFIRM_ORDER(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify()
          this.getList()
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    // 取消确认
    cancelConfirm(item) {
      let para = {
        order_no: item.order_no
      }
      this.loading = true
      CANCEL_ORDER_CONFIRM(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify()
          this.getList()
        } else {
          this.$notify(res.data.msg, 'error')
        }
      })
    },

    // 翻页
    changePage(val) {
      this.page = val
      this.getList()
    },

    // 获取列表
    getList() {
      let para = Object.assign({},this.params)
      if (para.orderType) delete para.orderType
      this.loading = true
      ADMIN_ORDER_LIST(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.total = res.data.total
          this._formatList(res.data.data)
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    // 格式化列表
    _formatList(data) {
      this.list = []
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        this.list.push(e)
      })
    },

    // 初始化订单状态
    _initOrderType() {
      this.orderType = this.$store.state.adminOrderParams.orderType ? this.$store.state.adminOrderParams.orderType : 'NOT_CONFIRM'
    }
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.my-order-admin {
  width: 1200px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
  .order-type-wrapper {
    width: 200px;
    height: 25px;
    border: 1px solid #ddd;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    border-radius: 3px;
    overflow: hidden;
    margin-top: 25px;

    .btn-order-type {
      display: inline-block;
      height: 25px;
      line-height: 25px;
      flex: 1;
      color: #333333;
      font-size: 14px;
      text-align: center;

      &.active {
        background-color: @blue-d;
        color: #fff;
      }
    }
  }
  .content {
    margin-top: 5px;
    width: 1200px;

    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      border: 1px solid #999;

      // 列表
      .table {
        width: 1500px;
        table-layout: fixed;
        font-size: 14px;
        text-align: center;
        position: relative;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;

            // 编辑实领数
            .cell-nums {
              margin: 0 auto;
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              width: 120px;
              height: 26px;
              border: 1px solid #999;
              border-radius: 3px;

              i {
                display: inline-block;
                height: 26px;
                width: 40px;
                line-height: 26px;
                text-align: center;
                background-color: @blue-d;
                color: #fff;
                font-size: 14px;
                cursor: pointer;
              }
              input {
                text-align: center;
                outline: none;
                border: none;
                width: 40px;
                font-size: 14px;
              }
            }

            input.remark {
              outline: none;
              border: 1px solid #ddd;
              font-size: 14px;
              height: 30px;
              line-height: 30px;
              box-sizing: border-box;
              width: 90%;
              margin: 0 5px;
              background: #fcfcfc;
            }
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;

            &.btn-approve {
              width: 55px;
              color: #ffffff;
              background-color: #00c36b;
              border: none;
              margin-right: 5px;
            }

            &.btn-reject {
              width: 55px;
              color: #ffffff;
              background-color: #ff6565;
              border: none;
            }
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }

    .btn-back {
      display: block;
      margin: 50px auto 20px;
      width: 298px;
      height: 38px;
      border-radius: 5px;
      line-height: 38px;
      text-align: center;
      background-color: @blue-d;
      color: #ffffff;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/MyOrderAdmin.vue